import axios from "axios";

// Production GR Attendance / Grengg Office Manager API (confirmed by Emergent Support).
// NOTE: intentionally a constant (not an env var) so Preview and Production can never drift
// to a different backend. Changing the API origin requires a deliberate code change + publish.
export const ATTENDANCE_API = "https://gr-attendance.emergent.host/api";

const TOKEN_KEY = "gre_staff_token";
const USER_KEY = "gre_staff_user";
const PERMS_KEY = "gre_staff_perms";

export const getToken = () => sessionStorage.getItem(TOKEN_KEY);

export const setSession = (token, user) => {
  sessionStorage.setItem(TOKEN_KEY, token);
  sessionStorage.setItem(USER_KEY, JSON.stringify(user || null));
  sessionStorage.removeItem(PERMS_KEY); // never carry a previous user's permission cache into a new login
};

export const getUser = () => {
  try {
    return JSON.parse(sessionStorage.getItem(USER_KEY));
  } catch {
    return null;
  }
};

export const setUser = (u) => sessionStorage.setItem(USER_KEY, JSON.stringify(u));

export const getCachedPerms = () => {
  try {
    return JSON.parse(sessionStorage.getItem(PERMS_KEY));
  } catch {
    return null;
  }
};

export const setCachedPerms = (p) => sessionStorage.setItem(PERMS_KEY, JSON.stringify(p ?? null));

export const clearSession = () => {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);
  sessionStorage.removeItem(PERMS_KEY);
};

export const staffApi = axios.create({ baseURL: ATTENDANCE_API, timeout: 30000 });

staffApi.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

staffApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/login")) {
      clearSession();
      if (window.location.pathname !== "/app/login") window.location.href = "/app/login";
    }
    return Promise.reject(err);
  }
);

export const fmtErr = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && x.msg) || JSON.stringify(x)).join(" ");
  return String(d);
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

export const fmtTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true });
  } catch {
    return iso;
  }
};
